import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { contactUsErrorsSelector, createContactEmail, setContactUsErrors } from 'src/store/app';

import { CustomButton, CustomInput, WhiteCard } from 'src/components';

import { EmailAmico, LetterIcon, TelegramIcon } from 'src/assets';
import './contacts.scss';

// const errorMessages = [
//   { id: 1, type: 'success', message: 'success message' },
//   { id: 1, type: 'error', message: 'error message' },
// ];

export const Contacts = () => {
  const { t } = useTranslation('contacts');

  const dispatch = useDispatch();

  const errors = useSelector(contactUsErrorsSelector);

  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    message: '',
  });

  const onSubmitForm = useCallback(
    (event) => {
      event.preventDefault();

      dispatch(createContactEmail({ payload: formData, setForm: setFormData }));
    },
    [dispatch, formData],
  );

  const onChangeInput = useCallback(
    (key) => (event) => {
      setFormData((prev) => ({ ...prev, [key]: event.target.value }));

      const copiedErrors = _.cloneDeep(errors);

      delete copiedErrors[key];

      dispatch(setContactUsErrors(copiedErrors));
    },
    [dispatch, errors],
  );

  return (
    <div className="contacts">
      <div className="contacts__image">
        <img src={EmailAmico} alt={EmailAmico} />
      </div>
      <div className="contacts-form">
        <WhiteCard>
          <div className="contacts-form__content">
            <h2>{t('title')}</h2>
            <div className="contacts-form__sub-title">{t('subTitle')}</div>
            <Link className="contacts__link" to="mailto:support@exok.cash">
              <img className="contacts__link__image" src={LetterIcon} alt={LetterIcon} />
              <h5>support@exok.cash</h5>
            </Link>
            <Link className="contacts__link" target="_blank" to="tg://resolve?domain=exok_manager">
              <img className="contacts__link__image" src={TelegramIcon} alt={TelegramIcon} />
              <h5>Telegram</h5>
            </Link>
            <Link
              className="contacts__link"
              target="_blank"
              to="tg://resolve?domain=ExOk_Exchange_bot"
            >
              <img className="contacts__link__image" src={TelegramIcon} alt={TelegramIcon} />
              <h5>Telegram Bot</h5>
            </Link>

            <h2>{t('contactUs')}</h2>

            <form className="contacts-form__main" onSubmit={onSubmitForm}>
              <div className="contacts-form__main__row">
                <CustomInput
                  placeholder={t('reviews:yourName')}
                  value={formData?.name}
                  onChange={onChangeInput('name')}
                  errorMessage={errors?.name}
                />
                <CustomInput
                  placeholder={t('reviews:emailtelegram')}
                  value={formData?.contact}
                  onChange={onChangeInput('contact')}
                  errorMessage={errors?.contact}
                />
              </div>
              <CustomInput
                type="text-area"
                placeholder={t('reviews:text')}
                value={formData?.message}
                onChange={onChangeInput('message')}
                errorMessage={errors?.message}
              />
              <div className="contacts-form__main__footer">
                {/* <div className="contacts-form__main__messages">
                  {errorMessages?.map((item) => (
                    <FormMessage key={item.id} type={item.type} message={item.message} />
                  ))}
                </div> */}
                <CustomButton title={t('reviews:send')} variant="filled" />
              </div>
            </form>
          </div>
        </WhiteCard>
      </div>
    </div>
  );
};
